import React from "react";
import { QRCodeSVG } from "qrcode.react";

const VcfQRCodePopup = ({ props, contactInfo, socialLinks, contactImage, getFormattedSocialLinks }) => {

    const data = `BEGIN:VCARD
VERSION:3.0
N:;${props?.rs?.sub_title};;;
FN:${props?.rs?.sub_title}
ORG:${props?.rs?.title}
TITLE:${props?.rs?.designation}
URL:https://app.businessbay.io/${props?.rs?.slug}
TEL;TYPE=CELL:${contactInfo?.contactInfoPhone}
${contactInfo?.optionalContactInfoPhone ? `TEL;TYPE=CELL;LABEL=AlternateMobile:${contactInfo.optionalContactInfoPhone}` : ''}
EMAIL;TYPE=INTERNET:${contactInfo?.contactInfoEmail}
ADR;TYPE=HOME:;${socialLinks?.getCOntactInfo}
URL:${contactInfo?.contactInfoWebUrl}
${getFormattedSocialLinks()}
${!!contactImage ? `PHOTO;ENCODING=b;TYPE=JPEG:${contactImage.replace(/^data:image\/\w+;base64,/, '')}` : ''}
X-ABADR:country
X-ABLabel:Title
X-ABLabel:eBusiness Card
END:VCARD`;

    return (
        <div className="canvas-container-qr-offline flex-column">
            <QRCodeSVG
                value={data}
                size={280}
                bgColor="#ffffff"
                fgColor="#000000"
                level="L"
                includeMargin={false}
            />
            <div className="sText font-Inter fs-4" style={{lineHeight:"20px", marginBottom:"-25px", marginTop:"5px"}}>Tap QR code to go online</div>
        </div>
    );
};

export default VcfQRCodePopup;